import { z } from 'zod'
import { applyFlightSchema } from '~library/models'
import { courtesyArrangementSuitCourtesySchema } from './courtesy-arrangement-suit-courtesy'

/** 禮遇安排紀錄 Schema */
export const courtesyArrangementRecordSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 禮遇安排日期 */
  arrangementTime: z.string(),
  /** 機票號碼 */
  ticketNumber: z.string(),
  /** EMD號碼 */
  emdNo: z.string(),
  /** 套裝子項目清單 */
  suitCourtesy: z.array(courtesyArrangementSuitCourtesySchema),
  /** 訂位代號 */
  pnr: z.string(),
  /** 出發日期 */
  departureTime: z.string(),
  /** 開票日期 */
  issueTime: z.string(),
  /** 排出行程 */
  excludeItinerary: z.boolean().optional(),
  /** 使用航段資訊 */
  applyFlight: z.array(applyFlightSchema)
})

export interface CourtesyArrangementRecord
  extends z.infer<typeof courtesyArrangementRecordSchema> {}
